import styled from 'styled-components';

export const Container = styled.div`
`;

export const HighlightLink = styled.span`
    font-weight: bold;
    text-decoration: none;
    transition: all 0.3s ease-in-out;
    
    &:hover {
      border-bottom: 2px solid white;
      text-decoration: none;
    }
`;